import * as d3 from 'd3'
export default {

  methods: {

    set_LocalValues() {
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.dataset = JSON.parse(JSON.stringify(this.Queries.SQL1[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.donut   = json.donut
      this.sundries   = json.sundries
      this.gauge   = json.gauge
      this.icon    = json.icon
      this.legends = json.legends
      this.sundries  = json.sundries
      this.keys    = json.keys
      this.filters = json.filters




      // rawData Pre_Processing
      this.rawData.slice(0, this.donut.styles.length).forEach((d,i) => {
        d.bgColor= this.donut.styles[i].bColor
        d.color= this.donut.styles[i].fColor
        d.stroke= this.donut.styles[i].sWidth
        d.opacity= this.donut.styles[i].opacity
        d.base= this.donut.styles[i].base
        d.ra= Number(this.donut.styles[i].radius)
      })


      // angle
      if (this.icon.display == 'Y') {
        this.angle.size = 270
        this.angle.start = 225
        this.angle.end = 495
      } else {
        this.angle.size = 360
        this.angle.start = 0
        this.angle.end = 360
      }
    },


  }
}